// =====================================================
// 📁 POSProductShared.ts
// =====================================================

import { ProductPanelItem } from '../../../../../types/productpanel/ProductPanelItem';

// =====================================================
// 🎯 Product Actions
// =====================================================

export interface ProductItemActions {
    onAddToCart?: (product: ProductPanelItem) => void;

    onIncreaseQuantity?: (product: ProductPanelItem) => void;

    onDecreaseQuantity?: (product: ProductPanelItem) => void;
}

// =====================================================
// 🎯 Shared Product Props
// =====================================================

export interface SharedProductItemProps
    extends ProductItemActions {
    product: ProductPanelItem;

    quantity?: number;

    loading?: boolean;

    disabled?: boolean;
}

// =====================================================
// 🎨 Product Animations
// =====================================================

export const PRODUCT_CARD_ANIMATION = {
    initial: {
        opacity: 0,
        scale: 0.92,
        y: 12,
    },

    animate: {
        opacity: 1,
        scale: 1,
        y: 0,
    },

    exit: {
        opacity: 0,
        scale: 0.92,
        y: 10,
    },

    transition: {
        duration: 0.2,
    },
};

// =====================================================
// 🎨 Product List Animation
// =====================================================

export const PRODUCT_LIST_ANIMATION = {
    initial: {
        opacity: 0,
        y: 10,
    },

    animate: {
        opacity: 1,
        y: 0,
    },

    exit: {
        opacity: 0,
        y: 10,
    },

    transition: {
        duration: 0.18,
    },
};

// =====================================================
// 💰 Helpers
// =====================================================

export const formatProductPrice = (
    price?: number,
): string => {
    if (price == null) {
        return '$0.00';
    }

    return `$${price.toFixed(2)}`;
};

// =====================================================
// 📦 Stock Helpers
// =====================================================

export const getStockLabel = (
    stock?: number,
    sellByRecipe?: boolean,
): string => {
    if (sellByRecipe) {
        return 'Por receta';
    }

    if (!stock || stock <= 0) {
        return 'Sin stock';
    }

    return 'Disponible';
};

// =====================================================
// 🎨 Stock Color Helpers
// =====================================================

export const getStockColor = (
    stock?: number,
    sellByRecipe?: boolean,
): string => {
    if (sellByRecipe) {
        return 'text-primary';
    }

    if (!stock || stock <= 0) {
        return 'text-red';
    }

    if (stock <= 5) {
        return 'text-yellow-500';
    }

    return 'text-[#3CA745]';
};